"use client";

import { CMSData } from "@/cms/models";
import { ApplicationFraction } from "@/utils/gql/graphql";
import React from "react";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

export interface SliderComponentProps {
  cmsData: CMSData;
  app: ApplicationFraction;
  items: any[];
  config: {
    navigation?: boolean;
    pagination?: {
      enabled: boolean;
      bulletColor?: string;
      bulletActiveColor?: string;
    };
    autoplay?: {
      delay: number;
      disableOnInteraction: boolean;
      pauseOnMouseEnter: boolean;
    };
    slidesPerView?: number | "auto";
    spaceBetween?: string;
    centeredSlides?: boolean;
    speed?: number;
    effect?: string;
  };
}

const SliderClientComponent: React.FC<{
  config: SliderComponentProps;
  items: any[];
}> = ({ config, items }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div
      className="relative h-full overflow-hidden"
      style={
        {
          "--swiper-pagination-bullet-inactive-opacity":
            config.config.pagination?.bulletColor || 0.2,
          "--swiper-pagination-color":
            config.config.pagination?.bulletActiveColor ||
            "var(--button-bg-color)",
          "--swiper-pagination-bullet-inactive-color":
            config.config.pagination?.bulletColor || "var(--button-bg-color)",
        } as React.CSSProperties
      }
    >
      <Swiper
        className="select-none h-full"
        slidesPerView={config.config.slidesPerView ?? "auto"}
        spaceBetween={config.config.spaceBetween ?? "1px"}
        centeredSlides={config.config.centeredSlides ?? false}
        speed={config.config.speed ?? 500}
        effect={config.config.effect ?? "slide"}
        fadeEffect={{
          crossFade: config.config.effect === "fade",
        }}
        navigation={config.config?.navigation}
        pagination={{
          enabled: config.config?.pagination?.enabled ?? false,
          clickable: true,
        }}
        autoplay={
          !config.config?.autoplay
            ? false
            : {
                delay: config.config.autoplay.delay ?? 1000,
                disableOnInteraction:
                  config.config.autoplay.disableOnInteraction ?? true,
                pauseOnMouseEnter:
                  config.config.autoplay.pauseOnMouseEnter ?? false,
              }
        }
        modules={
          [
            config.config.navigation ? Navigation : null,
            config.config.pagination ? Pagination : null,
            config.config.autoplay ? Autoplay : null,
            config.config.effect === "fade" ? EffectFade : null,
          ].filter(Boolean) as any
        }
      >
        {items.map((item, i) => {
          return (
            <SwiperSlide key={i} style={{ width: "80%" }}>
              {item}
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default SliderClientComponent;
